import { Button, type ButtonProps } from 'antd';
import styled from 'styled-components';

import { selectedToolbarButtonStyles } from 'components/Views/Creative/ToolbarStyles';

const ToolbarStyledButton = styled(Button)<{
  $selected?: boolean;
}>`
  align-items: center;
  display: flex;
  font-size: 20px;
  padding: 0 9px;

  ${(p) => p.$selected && selectedToolbarButtonStyles}
`;

export interface ToolbarButtonProps extends ButtonProps {
  selected?: boolean;
}

export function ToolbarButton({
  selected,
  children,
  ...passthruProps
}: ToolbarButtonProps) {
  return (
    <ToolbarStyledButton $selected={selected} {...passthruProps}>
      {children}
    </ToolbarStyledButton>
  );
}
